import React, { FC, useMemo } from 'react';
import { isFieldString, TenderSubCatName } from 'src/models/procurements/Tender/types';
import { InfoIcon } from 'src/common';
import { useTranslation } from 'react-i18next';
import { useTenderData } from 'src/models/procurements/Tender/hooks';
import { Competitors, TenderSubCat } from 'src/shared';

export const CompetitorsSubCat: FC = () => {
  const { t } = useTranslation();
  const { data } = useTenderData();
  const buyerOrgId = useMemo(() => {
    const buyerData = data?.generalCat[TenderSubCatName.Contact].boxes.buyerBoxes;
    return buyerData && !!buyerData.length && buyerData[0].fields && isFieldString(buyerData[0].fields[1])
      ? buyerData[0].fields[1].string ?? undefined
      : undefined;
  }, [data]);
  const subCat = useMemo(() => data?.generalCat[TenderSubCatName.Competitors], [data]);

  return subCat ? (
    <>
      <TenderSubCat subCat={subCat} actions={<InfoIcon desc={t('Competitors.competitorsDesc')} />}>
        <Competitors orgId={buyerOrgId} />
      </TenderSubCat>
    </>
  ) : null;
};

export default CompetitorsSubCat;
